<script>
  import { onMount } from "svelte"
  import getData from "./data"
  import MainContainer from "./components/MainContainer.svelte"

  let dataset = {}

  // prop passed from main.js
  export let parentUrl

  // Reactive declaration
  $: if (parentUrl) {
    loadDataset()
  }

  async function loadDataset() {
    const res = await getData(parentUrl)
    dataset = res
  }

  onMount(loadDataset)
</script>

{#if dataset.data && dataset.data.length > 0}
  <MainContainer {dataset} />
{:else}
  <div class="loading-container">
    <div class="loading" />
  </div>
{/if}

<style lang="scss" global>
  @use "./scss/main.scss";
</style>
